//import catalogos from './catalogos/sicpo'
//import funciones from './funcion/funcion'
import sistema from '../Convocatorias/sistema/Administracion/convocatorias'

const convocatorias = {
 // catalogos: catalogos,
 // funcion: funciones,
  sistema: sistema
}

export default convocatorias



//////////////////
// WEBPACK FOOTER
// ./static/js/api/Convocatorias/convocatoriasapi.js
// module id = null
// module chunks = 